import { Checkbox, CheckboxProps } from '@/components/Checkbox';
import { StandaloneComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';

interface ToggleProps extends CheckboxProps {
  onChange: (value: any) => void;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
}

export const Toggle: StandaloneComponent<ToggleProps> = ({ onChange, checked, defaultChecked, disabled, ...props }) => {
  return (
    <Checkbox
      {...mergeProps(
        {
          options: {
            $input: {
              onChange: ({ target: { checked } }: any) => onChange(checked),
              checked,
              defaultChecked,
              disabled,
            },
          },
        },
        props,
      )}
    />
  );
};
